import type { AgentToolCall } from '@multiplayer-app/ai-agent-types'

interface ParsedResponse {
  question?: string
  selectedOptions?: { label: string }[]
  freeText?: string
}

function parseUserResponse(userResponse: string): ParsedResponse | string {
  try {
    const parsed = JSON.parse(userResponse)
    return {
      question: typeof parsed.question === 'string' ? parsed.question : undefined,
      selectedOptions: Array.isArray(parsed.selectedOptions) ? parsed.selectedOptions : undefined,
      freeText: typeof parsed.freeText === 'string' ? parsed.freeText : undefined
    }
  } catch {
    return userResponse
  }
}

export const ApprovalStatusInline = ({ call }: { call: AgentToolCall }) => {
  if (call.approved === undefined) return null

  const parsed = call.userResponse ? parseUserResponse(call.userResponse) : null

  const renderResponse = () => {
    if (!parsed) return null
    if (typeof parsed === 'string') {
      return <span className='mp-agent-tool-approval-response'>{parsed}</span>
    }
    const answer = parsed.freeText ?? parsed.selectedOptions?.map((o) => o.label).join(', ')
    if (!parsed.question && !answer) return null
    return (
      <div className='mp-agent-tool-approval-result'>
        {parsed.question && <span className='mp-agent-tool-approval-question'>{parsed.question}</span>}
        {answer && <span className='mp-agent-tool-approval-response'>{answer}</span>}
      </div>
    )
  }

  return (
    <div className='mp-agent-tool-approval-status-inline'>
      {call.approved && renderResponse()}
      {call.approved ? (
        <div className='mp-agent-tool-approved'>
          <span>✓ Approved</span>
        </div>
      ) : (
        <span className='mp-agent-tool-denied'>✗ Denied</span>
      )}
    </div>
  )
}
